import { render, staticRenderFns } from "./CompanyFormPanel.vue?vue&type=template&id=1049f1a6&scoped=true"
import script from "./CompanyFormPanel.vue?vue&type=script&lang=js"
export * from "./CompanyFormPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyFormPanel.vue?vue&type=style&index=0&id=1049f1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049f1a6",
  null
  
)

export default component.exports